import { render, staticRenderFns } from "./recommend_order.vue?vue&type=template&id=7a8cabe5&"
import script from "./recommend_order.vue?vue&type=script&lang=js&"
export * from "./recommend_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports